<template>
<div>
    <div class="form-group">
        <label for="category"><strong>GRUPPO CATEGORIA</strong></label>  
        <select id='categoryGroup' :required="required" :disabled="!isActive" @change="$emit('update',categoryId)"  class="form-control" v-model="categoryId">
            <option v-if="optionBase" value="0"> -- Seleziona un gruppo categoria -- </option>  
            <option v-for="(item,index) in items" :key="index" :value="item.categoryId" >
                {{item.category}}
            </option>                    
        </select>  
    </div>
</div>

</template>
<script>
import api             from "@/api";
import {mapGetters }   from 'vuex';

export default {
  props : ['isActive','optionBase','required'] , 
  components: {},
  data() {
    return {

      categoryId             : 0,
      items                  : [],
      spinner                : false
           
    };
  },
  mounted: function() {
  
  },
  computed:
  {
      ...mapGetters(['company']) 
  },
  created: function() {
      this.getData()
  },
  methods: 
  {
    
    async getData()
    {
            
      let sp    = {'sp'    : 'spCategoryGroupingSelect'}
      
      let data  = {'companyId': this.company.Id}
      let json   = Object.assign(data, sp);

      await api.post(json).then(res => {
          
        

          if(res.status==200)
            {
              this.items  = res.data.recordsets[0]     
            }
           else if(res.status==500)
           {
                console.log(res.data)              
           } 
           else
            {
                console.log('Network Error.')                            
            } 
          

          }).catch(err => {
              
              console.log(err.message)    
              
          }).finally(() => {
          this.spinner = false
        });
      


      

    },
  
    
    
  
}

}
</script>
<style scoped>
.form-check-label{
  cursor:pointer
}
</style>